import React from 'react';

import {Wrapper, Content, Text} from './Header.styles'


const Header = ({colorone,colortwo}) => (

<Wrapper colorone={colorone} colortwo={colortwo}>
    <Content>
          <Text>
            <h1>TAFELS OEFENINGE</h1>

            </Text>  

    </Content>
</Wrapper>

);

export default Header;